import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplitpayBookingDetailsComponent } from './splitpay-booking-details.component';
import { SplitPaymentsPipeModule } from 'app/split-payments/split-payments-pipe/split-payments-pipe.module';
import { MomentTimezonePipeModule } from 'app/shared/module/pipe/moment-timezone-pipe.module';
import { VenuePipeModule } from 'app/venue/venue-pipe.module';
import { ButtonSharedModule, IconSharedModule, SpinnerSharedModule } from 'pf_styleguide';
import { ErrorsModule } from 'app/shared/module/errors/errors.module';

@NgModule({
  imports: [
    CommonModule,
    SplitPaymentsPipeModule,
    MomentTimezonePipeModule,
    VenuePipeModule,
    IconSharedModule,
    ButtonSharedModule,
    SpinnerSharedModule,
    ErrorsModule
  ],
  declarations: [SplitpayBookingDetailsComponent],
  exports: [SplitpayBookingDetailsComponent]
})
export class SplitpayBookingDetailsModule { }
